import { PATH_FRAGMENT_WITHOUT_SESSION } from './Path';
import { gql} from '@apollo/client';

export const GET_CATEGORIES = gql`
${PATH_FRAGMENT_WITHOUT_SESSION}
    query categories 
    {
        retrieveWithAtLeastOneItem {
            _id
            order
            title
            subtitle
            shortTitle
            type
            humanReadableId
            numberItems
            inDashboard
            infoTitleGenericPage
            infoGenericPage
            infoVisible
            showCategoryItemsType
            categoryItem {
                _id
                image
                contentType
                order
                exercise {
                    _id
                    title
                    estimatedTime
                    shortDescription
                    longDescription
                    reinforcementMessage
                    image
                    humanReadableId
                }
                activity {
                    _id
                    title
                    type
                    challengeable
                    numberOfDays
                    shortDescription
                    estimatedTime
                    image
                    designSystemColor
                    humanReadableId
                    session {
                        _id
                    }
                }
                technique {
                    _id
                    name
                    color
                    image
                    humanReadableId
                }
                categoryTarget {
                    _id
                    title
                }
                content {
                    _id
                    title
                    type
                    image
                    designSystemColor
                    activityType
                    humanReadableId
                    session {
                        _id
                    }
                }
                survey {
                    _id
                    session {
                        _id
                    }
                    title
                    image
                    designSystemColor
                    humanReadableId
                }
                path {
                    ...PathFieldsNoSession
                }
            }
        
        }
    }
`;